import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AccountService } from '@qaroni-app/account/services/account.service';
import { PasswordDTO } from '@qaroni-app/account/types/change-password';
import { ProfileViewEnum } from '@qaroni-app/account/types/profile-view.enum';
import { ImagesConfig } from '@qaroni-core/conf/images/images.config';
import { BackButtonComponent } from '@qaroni-shared/components/back-button/back-button.component';
import { InputErrorMessageComponent } from '@qaroni-shared/components/input-error-message/input-error-message.component';
import { LoadButtonDirective } from '@qaroni-shared/directives/load-button.directive';
import { AccountResetPasswordForm } from './account-reset-password.form';

@Component({
  selector: 'qaroni-account-reset-password',
  standalone: true,
  imports: [
    BackButtonComponent,
    FormsModule,
    InputErrorMessageComponent,
    LoadButtonDirective,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './account-reset-password.component.html',
  styleUrl: './account-reset-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountResetPasswordComponent
  extends AccountResetPasswordForm
  implements OnInit
{
  @Output() changeView = new EventEmitter<ProfileViewEnum>();

  protected hide = true;
  protected hideConfirm = true;
  public ImagesConfig = ImagesConfig;

  private accountService = inject(AccountService);
  private _cdr = inject(ChangeDetectorRef);

  public accountMessage$ = this.accountService.getMessage$();

  ngOnInit(): void {
    this.subs.add(this.accountMessage$.subscribe(this.getMessage));
  }

  private getMessage = (message: string): void => {
    if (message.length === 0) {
      this.disableLoading();
      this._cdr.markForCheck();
      return;
    }
  };

  public changeVisibility(): void {
    this.hide = !this.hide;
  }

  public changeVisibilityConfirm(): void {
    this.hideConfirm = !this.hideConfirm;
  }

  public changeViewInfo(): void {
    this.changeView.emit(ProfileViewEnum.INFO);
  }

  public onSubmit(): void {
    if (!this.validatedForm) {
      return;
    }

    this.enableLoading();

    const passwordDTO: PasswordDTO = {
      newPassword: this.password.value,
    };

    this.accountService.changePassword(passwordDTO);
  }
}
